import React from "react";
import { useRouter } from "next/router";
import Meta from "../../components/Meta";
import ContactForm from "../../components/contact/ContactForm";
import { getApps, getPage, getSiteSettings } from "../../lib/api";

const Contact = ({ page, apps = [] }) => {
  // "Request access" buttons link here as /contact?app=<slug>; start the message for them.
  const { query } = useRouter();
  const requestedApp = apps.find((app) => app.slug === query?.app);
  const initialText = requestedApp ? `Hi! I'd like access to the ${requestedApp.name} beta.` : "";

  return (
    <div>
      <Meta title={page?.title || "Contact"} desc={page?.metaDescription} />
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <img
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>
      <div className="pt-25">
        {/* <!-- Contact --> */}
        <section className="relative py-10">
          <div className="container">
            {/* The contact form is the only way to reach us: no phone, address or email on the site. */}
            <div className="mx-auto max-w-2xl">
              <div>
                <h2 className="font-display text-jacarta-700 mb-4 text-xl dark:text-white">
                  {page?.heading || "Get in touch"}
                </h2>
                {page?.intro && (
                  <p className="dark:text-jacarta-100 mb-8 text-lg leading-normal">{page.intro}</p>
                )}

                <ContactForm key={initialText} initialText={initialText} />
              </div>
            </div>
          </div>
        </section>
        {/* <!-- end contact --> */}
      </div>
    </div>
  );
};

export default Contact;

export async function getStaticProps({ draftMode = false }) {
  const [page, siteSettings, apps] = await Promise.all([
    getPage("contact", draftMode),
    getSiteSettings(draftMode),
    getApps(draftMode),
  ]);
  return {
    props: { page, siteSettings, apps, draftMode },
    revalidate: 10,
  };
}
